import styled from 'styled-components'
import ErrorIcon from 'components/Pages/ConfirmMail/Icons/Error'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Icon = styled.div`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
`
const Title = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  color: var(--color-night);
  font: var(--typography-18-24-semibold);
  text-align: center;
`
const Text = styled.div`
  color: var(--color-sw-60);
  text-align: center;
  font: var(--typography-14-20-regular);
  margin-bottom: 24px;
`

const Error = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Icon>
        <ErrorIcon />
      </Icon>
      <Title>{t('common.oops')}</Title>
      <Text>{t('confirmMail.indalidLink')}</Text>
    </Wrapper>
  )
}

export default Error
